import { Component } from '@angular/core';

@Component({
  selector: 'view-assist',
  templateUrl: './view-assist.component.html',
  styleUrls: ['./view-assist.component.css'],
  imports: []
})
export class ViewAssistComponent {

  constructor() {

  }

}
